import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function AlertHeader() {
  return <div className="bg-red-600 text-white py-3 px-4 text-center" data-id="element-1">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-bold animate-pulse" data-id="element-2">
        <AlertTriangle className="h-5 w-5 flex-shrink-0" data-id="element-3" />
        <p data-id="element-4">
          ¡ATENCIÓN URUGUAY! Si usted tiene más de 45 años y su glucosa marca
          más de 100, lea esto antes de que eliminen esta página.
        </p>
      </div>
    </div>;
}